export default __webpack_public_path__ + "static/media/green_tick_epicenter.a4105f01.svg";